// authService.ts
import { API_BASE_URL, OKTA_CLIENT_ID } from "@/config";
const OKTA_AUTH_BASE = "https://cbsi.okta.com/oauth2/v1/authorize";
const REDIRECT_URI = `${API_BASE_URL}/auth/callback`;
const STATE = "prod123"; // or randomState()
let count = 0;

export const authService = {

  async getMe() {
    const res = await fetch(`${API_BASE_URL}/auth/me`, {
      credentials: "include",
    });
    count++;
    if (res.status === 200) {
      return res.json();
    }

    if (res.status === 401 && count < 2) {
      const authRedirectUrl = `${OKTA_AUTH_BASE}?client_id=${OKTA_CLIENT_ID}&response_type=code&scope=openid%20profile%20groups&redirect_uri=${encodeURIComponent(
        REDIRECT_URI
      )}&state=${STATE}`;
      window.location.href = authRedirectUrl;
      return;
    }

    throw new Error(`Unexpected status from /auth/me: ${res.status}`);
  },

  async logout() {
    await fetch(`${API_BASE_URL}/auth/logout`, {
      method: "POST",
      credentials: "include",
    });
    // Optionally redirect to landing page
    window.location.href = "https://persona.xyz.com";
  },
};
// const OKTA_DOMAIN = "https://cbsi.okta.com";
// const CLIENT_ID = "0oa21rdyp67KfFU1P1d8";
// const REDIRECT_URI =
//   "https://esd-afa-dev-eus-backend-agents-ecbhfnbagzfngea0.eastus-01.azurewebsites.net/auth/callback";

// function generateState() {
//   // include return URL + random nonce
//   const returnUrl = `${window.location.origin}/home`;

//   return returnUrl;
// }

// export const authService = {
//   async getMe() {
//     const res = await fetch("/auth/me", {
//       credentials: "include",
//     });

//     if (res.status === 200) {
//       return res.json();
//     }

//     if (res.status === 401) {
//       const state = generateState();

//       const authUrl =
//         `${OKTA_DOMAIN}/oauth2/v1/authorize` +
//         `?client_id=${CLIENT_ID}` +
//         `&response_type=code` +
//         `&scope=openid%20profile%20groups` +
//         `&redirect_uri=${encodeURIComponent(REDIRECT_URI)}` +
//         `&state=${encodeURIComponent(state)}`;

//       window.location.href = authUrl;
//       return;
//     }

//     throw new Error(`Unexpected status: ${res.status}`);
//   },
// };
